import { Box } from "@mui/material";
import TkDownloadLink from "../../../components/atoms/TkDownloadLink";
import TkCheckbox from "../../../components/atoms/TkCheckbox";
import { TkRadioGroup } from "../../../components/atoms/TkRadioGroup";
import { TkGetCodeList } from "../../../utils/TkGetCode";
import { DemanderRelationship } from "../../../assets/data/Constants";
import TkLabelText from "../../../components/atoms/TkLabelText";

interface RelationshipInputProps {
  defaultValue?: string;
  other?: string;
}

interface DownloadLinkWithCheckProps {
  fileName: string;
  base64: string;
  defaultChecked: boolean;
  disabled: boolean;
  onClick: (e: any) => void;
}

const RelationshipInput: React.FC<RelationshipInputProps> = (props) => {
  const { defaultValue, other } = props;

  return (
    <Box className="SCRW410004">
      <Box className="relationshipInput">
        <TkRadioGroup
          radioPropsList={TkGetCodeList(DemanderRelationship)}
          wantToSetValue={defaultValue}
          disabled
        />
        {defaultValue === DemanderRelationship["その他"] && (
          <TkLabelText wantToSetValue={other} fullWidth disabled />
        )}
      </Box>
    </Box>
  );
};

/**
 * チェックボックス付きリンクダウンロード部品
 * @param {string} props.fileName -リンクの名称
 * @param {string} props.base64 -base64
 * @param {string} props.onClick -チェックボックスのクリックイベント
 * @returns DownloadLinkWithCheck
 */
const DownloadLinkWithCheck: React.FC<DownloadLinkWithCheckProps> = (props) => {
  const { fileName, base64, onClick, ...rest } = props;

  const handleClick = (event: any) => {
    onClick(event.target.checked);
  };

  return (
    <Box className="SCRW410004">
      <Box className="downloadLinkWithCheck">
        <TkDownloadLink
          dataname={fileName}
          base64filedata={base64}
          downloadBase64
        />
        <TkCheckbox label="再提出" onClick={handleClick} {...rest} />
      </Box>
    </Box>
  );
};

export { DownloadLinkWithCheck, RelationshipInput };
